// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
export const OneClickJoinContainerEditableDynamic = dynamic(() =>
  import('./OneClickJoinContainer').then(module => module.OneClickJoinContainerEditable)
);
export { OneClickJoinContainerEditable } from './OneClickJoinContainer';
